import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import ProductPickerDesktop from './desktop';
import ProductPickerMobile from './mobile';
import useProductPicker from './useProductPicker';

const ProductPicker = (props) => {
  const isMobile = useIsMobile(992);
  const viewModel = useProductPicker(props);

  return isMobile ? <ProductPickerMobile viewModel={viewModel} /> : <ProductPickerDesktop viewModel={viewModel} />;
};

export default ProductPicker;
